import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";
import { toTitleCase } from "../../../../Utils/stringUtls";
import { expectedHours } from "../../Channels/CustomerServiceLiveOperator";

const ContactCenterServicesOverview = ({ data }) => {
  const {
    contact_center_service_would_you_like_contact_center_service,
    contact_center_service_toll_free_number,
    contact_center_service_support_language,
    contact_center_service_support_language_other,
    contact_center_service_expected_hours_of_operation_for_customer_service,
    contact_center_service_expected_hours_of_operation_for_customer_service_custom_hrs,
    contact_center_service_do_you_want_i2c_to_provide_backup_or_overflow,
    contact_center_service_support_hours_required,
  } = data["3_6"];

  const languageValue = [
    ...(contact_center_service_support_language ?? [])
      .filter((l) => l?.length && l !== "other")
      .map(toTitleCase),
    ...(contact_center_service_support_language?.includes("other") &&
    contact_center_service_support_language_other?.length
      ? [
          `Other (${toTitleCase(contact_center_service_support_language_other)})`,
        ]
      : []),
  ].join(", ");

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid grid" className="review-summary-gap">
        <div i2c-grid="12@md">
          <ReviewSummarySectionHeading title="Contact Center Services (Live Operator)" />
        </div>
        <ReviewAttribute
          label="Would you like Contact Center Services Live Operator?"
          value={
            contact_center_service_would_you_like_contact_center_service?.length
              ? toTitleCase(
                  contact_center_service_would_you_like_contact_center_service,
                )
              : "-"
          }
        />
        <ReviewAttribute
          label="Toll-free number"
          value={
            contact_center_service_toll_free_number?.length
              ? toTitleCase(contact_center_service_toll_free_number)
              : "-"
          }
        />

        <ReviewAttribute
          label="CSR support Language"
          value={languageValue || "-"}
        />

        <ReviewAttribute
          label="What are the expected hours of operation for customer service?"
          value={
            contact_center_service_expected_hours_of_operation_for_customer_service?.length
              ? contact_center_service_expected_hours_of_operation_for_customer_service ===
                "other"
                ? `Other (${toTitleCase(
                    contact_center_service_expected_hours_of_operation_for_customer_service_custom_hrs,
                  )})`
                : contact_center_service_expected_hours_of_operation_for_customer_service ===
                    "24_7"
                  ? "24/7"
                  : expectedHours.find(
                      (option) =>
                        option.value ===
                        contact_center_service_expected_hours_of_operation_for_customer_service,
                    )?.label ||
                    toTitleCase(
                      contact_center_service_expected_hours_of_operation_for_customer_service,
                    )
              : "-"
          }
        />

        <ReviewAttribute
          label="Do you want i2c to provide back-up or overflow customer service?"
          value={
            contact_center_service_do_you_want_i2c_to_provide_backup_or_overflow?.length
              ? toTitleCase(
                  contact_center_service_do_you_want_i2c_to_provide_backup_or_overflow,
                )
              : "-"
          }
        />
        {contact_center_service_do_you_want_i2c_to_provide_backup_or_overflow ===
          "yes" && (
          <ReviewAttribute
            label="Support Hours Required"
            value={
              contact_center_service_support_hours_required
                ? contact_center_service_support_hours_required
                : "-"
            }
          />
        )}
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default ContactCenterServicesOverview;
